import React, { useContext, useState } from "react"
import Button from "../Button"
import TextField from "../TextField"
import { ButtonGroup, FormGroup } from "./displays"
import AppContext from "../../shared/AppContext"
import FolderSelect from "../../views/MyFavorites/components/FolderSelect"
import { Mutation } from "react-apollo"
import CREATE_FAVORITES_FILE from "../../graphql/createFavoritesFile.graphql"
import { FAVORITE_TYPE } from "../FavoriteButton/const"
import { MESSAGE_TYPE } from "./const"
import { ModalMessage } from "../Modal"

const TopicsForm = (props) => {
  const { id, name, slug, imageURL, onCloseModal, refetch } = props

  const { trackEvent } = useContext(AppContext)

  const [favoriteName, setFavoriteName] = useState(name)
  const [description, setDescription] = useState("")
  const [folderName, setFolderName] = useState("")
  const [folderId, setFolderId] = useState("")
  const [message, setMessage] = useState({ type: "", text: "" })

  const resetForm = () => {
    setFavoriteName(name)
    setDescription("")
    setFolderName("")
    setFolderId("")
    setMessage("")
  }

  const handleAddFavorite = (mutation) => {
    if (!favoriteName) {
      setMessage({
        type: MESSAGE_TYPE.REQUIRED,
        text: "Please fill in all required fields.",
      })

      return
    }
    mutation({
      variables: {
        name: favoriteName,
        slug: `/vendor/${slug}`,
        favoriteType: FAVORITE_TYPE.VENDOR,
        description:
          description ||
          `${name}'s vendor page with the most relevant updated datasets and related research.`,
        folderId: folderId,
        metadata: {
          imageURL: imageURL,
          topicId: id,
        },
      },
    })
      .then(({ data }) => {
        if (
          data &&
          data.createFavoritesFile &&
          data.createFavoritesFile.response
        ) {
          setMessage({
            type: data.createFavoritesFile.response.payload,
            text: data.createFavoritesFile.response.message,
          })
        }

        refetch && refetch()
      })
      .catch((err) => {
        setMessage({
          type: MESSAGE_TYPE.SAVE_ERROR,
          text:
            "Oh no! Something went wrong. Please go to https://app.etr.ai/help to get support.",
        })
        console.log("Topic add favorite form error", err)
      })
  }

  if (MESSAGE_TYPE.SUCCESS === message.type) {
    trackEvent &&
      trackEvent("Added Favorite", {
        name: favoriteName,
        vendorName: name,
        slug: slug,
        favoriteType: FAVORITE_TYPE.VENDOR,
      })

    return (
      <>
        <ModalMessage
          messageType={MESSAGE_TYPE.SUCCESS}
          text={message.text}
          closeModal={() => {
            onCloseModal(false)
            resetForm()
          }}
        />
      </>
    )
  }

  return (
    <div>
      <FormGroup>
        <label>
          Vendor <i>(Required)</i>
        </label>
        <TextField
          required
          placeholder="Favorite Name"
          name="name"
          fullWidth={true}
          value={favoriteName}
          onChange={(e) => {
            if (e) setFavoriteName(e.target.value)
          }}
        />
      </FormGroup>
      <FormGroup>
        <label>
          Folder Name <i>(optional)</i>
        </label>
        <FolderSelect
          folderName={folderName}
          folderId={folderId}
          setFolderName={setFolderName}
          setFolderId={setFolderId}
          placeholder="Select or create a new folder"
        />
      </FormGroup>
      <FormGroup>
        <label>
          Description <i>(optional)</i>
        </label>
        <TextField
          fullWidth={true}
          placeholder="Brief description for this favorite"
          required={false}
          value={description}
          onChange={(e) => {
            if (e) setDescription(e.target.value)
          }}
        />
      </FormGroup>
      {message.type && (
        <>
          <ModalMessage
            messageType={message.type}
            text={message.text}
            style={{ textAlign: "right", color: "red" }}
          />
        </>
      )}
      <ButtonGroup>
        <Button
          classes={["btn-cancel"]}
          style={{ marginRight: "1rem" }}
          action={() => {
            onCloseModal(false)
            resetForm()
          }}
        >
          Cancel
        </Button>
        <Mutation mutation={CREATE_FAVORITES_FILE}>
          {(mutation) => {
            return (
              <Button
                classes={["btn-primary"]}
                action={() => {
                  handleAddFavorite(mutation)
                }}
              >
                Add To Favorites
              </Button>
            )
          }}
        </Mutation>
      </ButtonGroup>
    </div>
  )
}

export default TopicsForm
